import { api } from './http';
import type { Payment, PaymentInput, PaymentStats } from './types';

export const payments = {
  list: (signal?: AbortSignal) => api.get<{
    payments: Payment[];
    stats: PaymentStats;
    nextInvoice: string;
    members: { id: number; name: string; email: string; plan?: string }[];
  }>('/payments', signal),
  get: (id: number) => api.get<{ payment: Payment }>(`/payments/${id}`),
  create: (f: PaymentInput) => api.post<{ payment: Payment }>('/payments', f),
  update: (id: number, f: PaymentInput) => api.put<{ payment: Payment }>(`/payments/${id}`, f),
  remove: (id: number) => api.del<{ ok: true }>(`/payments/${id}`),
};
